import React from 'react';
import MasterLayout from '../../components/MasterLayout';

const Vendors = () => {
  const columns = [
    { key: 'code', label: 'Code' },
    { key: 'name', label: 'Name' },
    { key: 'vendor_type', label: 'Type' },
    { key: 'city', label: 'City' },
    { key: 'contact_person', label: 'Contact Person' },
    { key: 'gstin', label: 'GSTIN' },
    { key: 'payment_terms', label: 'Payment Terms' },
    { key: 'is_active', label: 'Status' },
  ];

  const formFields = [
    { name: 'code', label: 'Code', required: true, placeholder: 'VND001' },
    { name: 'name', label: 'Name', required: true, placeholder: 'Vendor Name' },
    { 
      name: 'vendor_type', 
      label: 'Vendor Type', 
      type: 'select',
      options: [
        { value: 'RM', label: 'RM (Raw Material)' },
        { value: 'CONSUMABLES', label: 'Consumables' },
        { value: 'BOP', label: 'BOP (Bought Out Parts)' },
        { value: 'MB', label: 'M/B (Masterbatch)' },
      ]
    },
    { name: 'address', label: 'Address', type: 'textarea', fullWidth: true },
    { name: 'city', label: 'City', placeholder: 'City' },
    { name: 'state', label: 'State', placeholder: 'State' },
    { name: 'country', label: 'Country', placeholder: 'Country' },
    { name: 'pincode', label: 'Pincode', placeholder: 'Pincode' },
    { name: 'phone', label: 'Phone', placeholder: 'Phone Number' },
    { name: 'email', label: 'Email', type: 'email', placeholder: 'email@vendor.com' },
    { name: 'contact_person', label: 'Contact Person', placeholder: 'Contact Name' },
    { name: 'contact_phone', label: 'Contact Phone', placeholder: 'Contact Phone' },
    { name: 'gstin', label: 'GSTIN', placeholder: 'GSTIN Number' },
    { name: 'pan', label: 'PAN', placeholder: 'PAN Number' },
    { name: 'bank_name', label: 'Bank Name', placeholder: 'Bank Name' },
    { name: 'bank_account', label: 'Bank Account', placeholder: 'Account Number' },
    { name: 'ifsc_code', label: 'IFSC Code', placeholder: 'IFSC Code' },
    { name: 'payment_terms', label: 'Payment Terms (Days)', type: 'number', placeholder: '30' },
    { name: 'is_active', label: 'Status', type: 'boolean', defaultValue: true },
  ];

  return (
    <MasterLayout
      title="Vendors"
      endpoint="vendors"
      columns={columns}
      formFields={formFields}
      permissions={['ADMIN', 'RM_STORE']}
    />
  );
};

export default Vendors;
